import SearchInput from "../../../components/SearchInput/SearchInput";
import SelectInput from "../../../components/SelectInput/SelectInput";
import Buttons from "../../../components/Buttons/Buttons";
import { PlusIcon } from "../../../assets/icons-components/Icons";
import { APP_PLATFORM_OPTIONS } from "../../../utils/appPlatform";

const AppVersionsHeader = ({
  searchQuery,
  onSearchChange,
  platformFilter,
  onPlatformFilterChange,
  onAddVersion,
}) => (
  <div className="mainadd_header1">
    <div className="mainadd_header1_left">
      <SearchInput
        className="mainadd_header1_center_searchbar"
        name="searchQuery"
        placeholder="Search by version or release notes"
        value={searchQuery}
        onChange={onSearchChange}
      />
    </div>
    <div className="mainadd_header1_center">
      <SelectInput
        name="platformFilter"
        value={platformFilter}
        onChange={onPlatformFilterChange}
        options={APP_PLATFORM_OPTIONS}
        placeholder="All Platforms"
        clearable
        style={{ minWidth: 170 }}
      />
      <div className="mainadd_header1_center_addbtn">
        <Buttons
          text="Add New Version"
          type="button"
          variant="primary"
          fullWidth={false}
          style={{ height: 40, whiteSpace: "nowrap" }}
          onClick={onAddVersion}
          icon={<PlusIcon />}
        />
      </div>
    </div>
  </div>
);

export default AppVersionsHeader;
